// A4 page dimensions (in pixels at 96 DPI standard)
export const PDF_PAGE_DIMENSIONS = {
  width: 794, // A4 width at 96 DPI
  height: 1123, // A4 height at 96 DPI
  paddingPx: 40,
  fontFamily: "system-ui, -apple-system, sans-serif",
} as const;

// Derived layout values
export const PDF_PAGE_CONTENT_WIDTH = PDF_PAGE_DIMENSIONS.width - 2 * PDF_PAGE_DIMENSIONS.paddingPx;
export const PDF_PAGE_CONTENT_HEIGHT =
  PDF_PAGE_DIMENSIONS.height - 2 * PDF_PAGE_DIMENSIONS.paddingPx;

// Chart data points cap for SVG rendering (avoids excessive point counts for long missions)
// ~1 point per few pixels at typical chart widths — visually indistinguishable from full-res
export const CHART_MAX_POINTS = 150;

// Brand color for PDF export (Antaris blue)
export const PDF_BRAND_BLUE = "#0087CD";

// Single color for all subsystem mini-charts (PDF export)
export const SUBSYSTEM_CHART_COLOR = PDF_BRAND_BLUE;

// Deck/face label mapping for PDF export (distinct from live-app labels)
export const PDF_DECK_LABEL_MAP: Record<string, { label: string; subLabel?: string }> = {
  PX:   { label: "Deck 0", subLabel: "Nadir Pointing (Yaw)" },
  NX:   { label: "Deck 3", subLabel: "Sun Pointing" },
  PY:   { label: "+Y", subLabel: "Roll" },
  NY:   { label: "-Y" },
  PZ:   { label: "+Z", subLabel: "Pitch" },
  NZ:   { label: "-Z" },
  INT1: { label: "Deck 1" },
  INT2: { label: "Deck 2" },
};

export function getPdfDeckLabel(key: string): string {
  return PDF_DECK_LABEL_MAP[key]?.label ?? key;
}
